import React, { useEffect, useState } from 'react';
import moment from 'moment';
import { getDigitalAudience } from '../../../utils/apiMiniWidget';
import { StyledWrapper } from './style';
import { API_DIGITAL_DOWNLOAD } from '../../../constants/api';
import { navigateToFile } from '../../../utils/navigate';
import { DigitalAudienceDate } from '../../views/DigitalAudienceDate';

const DigitalAudience = () => {
  const [data, setData] = useState(undefined);

  useEffect(() => {
    getDigitalAudience()
      .then(digitalAudienceData => {
        setData(digitalAudienceData);
      })
      .catch(error => {
        console.error('Error desde DigitalAudience', error);
      });
  }, []);

  const downloadButton = () => {
    if (data && data.length >= 1) {
      navigateToFile(`${API_DIGITAL_DOWNLOAD}${data[0].clientPath}`);
    }
  };

  let publishDate;
  let otherTitle;
  if (data && data.length > 0) {
    publishDate = moment(data[0].publishDate);
    otherTitle = data[0].title;
  }
  return (
    <StyledWrapper>
      {data && data.length > 0 && (
        <DigitalAudienceDate
          dayWeek={publishDate.format('ddd')}
          numberWeek={publishDate.format('DD')}
          text={otherTitle}
          onClick={downloadButton}
        />
      )}
    </StyledWrapper>
  );
};

export default DigitalAudience;
